import * as React from "react";
import { useState, useEffect } from "react";
import {
    Button,
    Modal,
    Box,
    CircularProgress,
    FormControlLabel, Pagination,
    Switch,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TablePagination,
    TableRow,
    Typography,
    Stack,
  Avatar,
  Input,
    TextField
} from "@mui/material";
import { IoMdRefreshCircle } from "react-icons/io";
import FunctionsData from "../../../Functions/FunctionsData";
import 'react-day-picker/lib/style.css';
import CampaignsAddCampaign from "./CampaignsAddCampaign";
import CampaignsShowTableRow from "./CampaignsShowTableRow";
import uploadImageToBlob from "../../../Components/AzureBlobService/UploadFiletoAzure";

export default function Campaigns({ community, inspectors,outreach }) {
    const [loadingVets, setLoadingVets] = useState(true);
    const [dataVets, setDataVets] = useState([]);
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState([]);
    const [dataFiltered, setDataFiltered] = React.useState([]);
    const [isOpen, setIsOpen] = React.useState(false);
    const [showInactive, setShowInactive] = React.useState(false);
    const [showArchived, setShowArchived] = React.useState(false);
    const [filter, setFilter] = useState("");
    const [voucherMessage, setVoucherMessage] = React.useState(false);

    const [page, setPage] = React.useState(1);
    const [totalPages, setTotalPages] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(5);
    const [totalRows, setTotalRows] = React.useState(99999);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    useEffect(() => {
        if (page !== 1) {
            setPage(1)
        }
	    setLoading(true);
    }, [rowsPerPage, showInactive, showArchived]);

    useEffect(() => {

        const active = showInactive === true ? 0 : 1;
        const archived = showArchived === true ? 1 : 0;

        let url = `/api/campaign/?page=${1}&limit=${999999}&active=${active}&archived=${archived}&filter=${filter}`;
        if(inspectors) url = `/api/campaign/inspectors/?page=${1}&limit=${999999}&active=${active}&archived=${archived}&filter=${filter}`;
        if(outreach) url = `/api/campaign/outreach/?page=${1}&limit=${999999}&active=${active}&archived=${archived}&filter=${filter}`;
        if(!!community && !inspectors && !outreach) url = `/api/campaign/community/?page=${1}&limit=${999999}&active=${active}&archived=${archived}&filter=${filter}`;

        FunctionsData.fetchDataGet(
            FunctionsData.getApiUrl(url),
            setData,
            loading,
            setLoading
        )
		
    }, [loading]);

    useEffect(() => {
        FunctionsData.fetchDataGet(FunctionsData.getApiUrl('/api/vet'), setDataVets, loadingVets, setLoadingVets);
    }, [loadingVets]);

    useEffect(() => {
		const filtered = data.filter((row) => String(row?.name).toLowerCase().includes(filter.toLowerCase().trim()) || filter === '');
	    const d = (filtered.length > 0 ? filtered.slice((page - 1) * rowsPerPage, page * rowsPerPage) : []);
	    setDataFiltered(filtered.length > 0 ? d : []);
		setTotalPages(Math.ceil(filtered.length / rowsPerPage));
		setTotalRows(d.length);
    }, [data, filter,page]);


    async function updateCampaigns(col, val, id) {
        let requestOptionsVoucher = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', token: sessionStorage.sTkn },
            body: JSON.stringify({
                [col]: val,
            }),
        };

        await fetch(FunctionsData.getApiUrl("/api/campaign/") + id, requestOptionsVoucher)
            .then((response) => response.json())
            .then((res) => {
                let t = data;
                for (let x in t) {
                    if (t[x]['id'] === id) {
                        t[x][col] = val;
                    }
                }
                setData([...t]);
                // setLoading(true);
            });
    }

    if (loading === true || loadingVets === true) {
		return <CircularProgress sx={{ margin: "50px auto", display: "block" }} />;
	}

    return (
        <>
            <TableContainer>
                <TextField
                    id="standard-basic"
                    placeholder={"Filter campaigns ..."}
                    variant="outlined"
                    size={"small"}
                    sx={{ width: '100%' }}
                    value={filter}
                    onChange={(e) => setFilter(e.target.value)}
                />
                <ShowButtonNew
                    {...{
                        showInactive,
                        setShowInactive,
                        setIsOpen,
                        showArchived,
                        setShowArchived,
                        setLoading,
                    }}
                />
                
               
                <CampaignsAddCampaign
                    setLoading={setLoading}
                    setIsOpen={setIsOpen}
                    isOpen={isOpen}
                    currentData={{}}
                    mode={"new"}
                    key={Date.now()}
                    community={community}
                    inspectors={inspectors}
                    outreach={outreach}
                />

                <div style={{width:'100%', textAlign:'right', marginBottom:20}}>
                    <Pagination count={totalPages} page={page} onChange={handleChangePage} shape={"rounded"} />
                </div>

                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                    <TableHead>
                        <TableRow>
                            <TableCell sx={{ width: '50px' }} align="center">
                                Active
                            </TableCell>
                            <TableCell>Campaign</TableCell>
                            <TableCell>Vouchers</TableCell>
                            <TableCell>Merco#</TableCell>
                            <TableCell>Postcodes</TableCell>
                            <TableCell>Additional vets</TableCell>
                            {!outreach && <TableCell>Opted in Vet Clinics</TableCell>}
                            <TableCell>Notify vets</TableCell>
                            <TableCell align="left">Start</TableCell>
                            <TableCell align="left">End</TableCell>
                            <TableCell align="center">Archive</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {dataFiltered.map((row, idx) => {
							
                            const tags =
                                String(row.postcodes) !== 'null' && String(row.postcodes) !== ''
                                ? String(row.postcodes).split(',')
                                : [];

                            if (showInactive === false && row.active === 0) return null;
                            if (showInactive === true && row.active === 1) return null;
                            if (showArchived === true && row.archived === 0) return null;
                            if (showArchived === false && row.archived === 1) return null;
                            return (
                                <CampaignsShowTableRow
                                    {...{ community, inspectors,outreach }}
                                    key={row.id}
                                    row={row}
                                    idx={idx}
                                    tags={tags}
                                    updateCampaigns={updateCampaigns}
                                    setLoading={setLoading}
                                    vets={dataVets}
                                    setVoucherMessage={setVoucherMessage}
                                    voucherMessage={voucherMessage}
                                />
                            );
                        })}
                    </TableBody>
                </Table>
            </TableContainer>
            <div style={{width:'100%', textAlign:'right', marginBottom:20, marginTop:20}}>
                <Pagination count={totalPages} page={page} onChange={handleChangePage} shape={"rounded"} />
            </div>
        </>
    );
}

const ShowButtonNew = ({
    showInactive,
    setShowInactive,
    setIsOpen,
    showArchived,
    setShowArchived,
    setLoading,
}) => {
  const [open, setOpen] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);
const [uploadedImageUrl, setUploadedImageUrl] = useState(null);
  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
    setSelectedFile(null);
    setPreviewUrl(null);
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setSelectedFile(file);

    if (file && file.type.startsWith('image/')) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreviewUrl(reader.result);
      };
      reader.readAsDataURL(file);
    } else {
      setPreviewUrl(null);
    }
  };

const handleUpload = async () => {
  if (!selectedFile) {
    alert("No file selected");
    return;
  }

  alert(`Uploading: ${selectedFile.name}`);

  try {
    const fixedFileName = "sponsor.jpg"; 
    const fileInput = new File([selectedFile], fixedFileName, { type: selectedFile.type });
    const formData = new FormData();
    formData.append("image", fileInput);
   
    const imageUrl = await fetch(FunctionsData.getApiUrl("/api/azurefilesupload/uploadSponsorImage"), {
			method: 'POST',
			headers: {
				
				'token': FunctionsData.getSessionToken()
			},
			 body: formData,
		})
			.then(res => res.json())
  .then(d => {
    console.log("Uploaded:", d);
    return d.imageUrl;
  })
  .catch(err => {
    console.error("Upload error:", err);
    return false;
  });	
    setUploadedImageUrl(`${imageUrl}?t=${Date.now()}`);

    console.log("Image uploaded to:", imageUrl);
  } catch (err) {
    console.error("Upload failed:", err);
  }

  handleClose();
};


    return (
        <div>
            <Button
                sx={{ margin: 2 }}
                variant={"contained"}
                onClick={() => setIsOpen(true)}
            >
                Add new campaign
            </Button>

          
      {<Button variant="contained" onClick={handleOpen} sx={{mr:2}}>
        Add Sponsor
      </Button>}

      <Modal open={open} onClose={handleClose}>
        <Box sx={modalStyle}>
          <Typography variant="h6" mb={2}>
            Upload File
          </Typography>

          <Input  type="file" onChange={handleFileChange} sx={{ paddingBottom:1}} />

 {selectedFile && (
  <Stack direction="row" spacing={2} alignItems="center" mt={2}>
    {uploadedImageUrl ? (
      <Avatar
        src={uploadedImageUrl}
        variant="rounded"
        sx={{ width: 300, height: 100 }}
      />
    ) : previewUrl ? (
      <Avatar
        src={previewUrl}
        variant="rounded"
        sx={{ width: 300, height: 100 }}
      />
    ) : (
      <Avatar sx={{ width: 60, height: 60 }}>
        {selectedFile.name[0].toUpperCase()}
      </Avatar>
    )}
    <Typography variant="body2" noWrap sx={{ maxWidth: '250px' }}>
      {selectedFile.name}
    </Typography>
  </Stack>
)}

          <Stack direction="row" spacing={2} justifyContent="flex-end" mt={4}>
            <Button variant="contained" onClick={handleUpload}>
              Upload
            </Button>
            <Button variant="outlined" onClick={handleClose}>
              Cancel
            </Button>
          </Stack>
        </Box>
      </Modal>
   
            <FormControlLabel
                control={
                    <Switch
                        checked={showInactive}
                        onChange={() => setShowInactive(!showInactive)}
                    />
                }
                label="Show inactive"
            />
            <FormControlLabel
                control={
                    <Switch
                        checked={showArchived}
                        onChange={() => setShowArchived(!showArchived)}
                    />
                }
                label="Show archived"
            />
            <FormControlLabel
                control={
                    <IoMdRefreshCircle
                        size={35}
                        onClick={() => setLoading(true)}
                    />
                }
                label=""
            />
        </div>
    );
}



const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 600, // ⬅️ Increased width
  bgcolor: 'white',
  boxShadow: 24,
  p: 4,
  borderRadius: 2,
   overflow: 'auto',
};


